import { createGetOptionsNoPropsFn } from '@common/selectOptions.services';
import { IVoItem } from './voItem.models';

export const apiRoutes = {
  getAllVoItems: '/VoItems',
};

export const getAllVoItemsAsync = createGetOptionsNoPropsFn<IVoItem>(apiRoutes.getAllVoItems);
